'use strict';

export default selector => {
    if (!selector) {
        throw new Error('Selector is empty');
    }

    selector = typeof selector === 'string' && document.querySelector(selector);

    if (! selector) {
        return;
    }

    require.ensure([], require => {
        const
            Vue = require('vue'),
            Validator = require('vue-validator'),
            Resource = require('vue-resource'),
            App = require('./formsApp/App.vue');

        Vue.use(Validator);
        Vue.use(Resource);
        Vue.config.silent = true;
        new Vue(App).$mount(selector);

    });
};


// WEBPACK FOOTER //
// ./vue_application/bootstrap.js